var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { BaseComponent } from '../../utils/BaseComponent';
let ActiveTab = class ActiveTab extends BaseComponent {
    render() {
        const position = `${this.width * this.activeTab}px`;
        const width = `${this.width}px`;
        return html `
        <div class="w-full">
            <div style=${styleMap({
            transform: `translateX(${position})`,
            width: width
        })} class="transition bg-primary h-4"></div>
        </div>
    `;
    }
};
__decorate([
    property({ type: Number })
], ActiveTab.prototype, "activeTab", void 0);
__decorate([
    property({ type: Number })
], ActiveTab.prototype, "width", void 0);
ActiveTab = __decorate([
    customElement('trust-tab-active')
], ActiveTab);
export { ActiveTab };
//# sourceMappingURL=tabActive.js.map